(() => {
  if (window.rubinaaGlovesBundleSyncLoaded) return;
  window.rubinaaGlovesBundleSyncLoaded = true;
  const handle = 'windproof-winter-gloves-touchscreen-gloves-thermal-warm-gloves-for-men-and-women';
  const totals = new Map([[2, 2999], [4, 4999], [10, 9998]]);
  const initialized = new WeakSet();

  function initialize(root) {
    const mounts = root.querySelectorAll('[data-gloves-bundle-sync]');
    mounts.forEach(mount => {
      const productInfo = mount.closest('product-info') || mount.closest('section')?.querySelector('product-info');
      if (!productInfo) return;
      const offer = productInfo.querySelector('quantity-breaks');
      const productForm = productInfo.querySelector('product-form');
      const form = productForm?.querySelector('form');
      if (!offer || !form || initialized.has(offer)) return;
      let product;
      try {
        product = JSON.parse(mount.querySelector('[data-gloves-product-json]').textContent);
      } catch {
        return;
      }
      const sourceUrl = productInfo.dataset.url || '';
      if (product.handle !== handle && !sourceUrl.split('?')[0].endsWith('/' + handle)) return;
      const variants = product.variants;
      const events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
      const idInput = form.querySelector('[name="id"]');
      const variantInputs = form.querySelector('.product-form__variants');
      const addButton = form.querySelector('[name="add"]');
      if (!Array.isArray(variants) || !idInput || !variantInputs || !addButton) return;
      initialized.add(offer);
      const remembered = new Map();
      const rendered = new WeakMap();
      let queued = false;
      let syncing = false;
      let ownError = false;
      let paymentPending = false;
      let preparedPaymentSignature = '';
      let preparedProductSignature = '';
      const compareBasis = mount.dataset.compareBasis || 'compare_price';
      const fallbackMoney = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      const money = cents => typeof window.formatMoney === 'function' ? window.formatMoney(Math.round(cents), offer.dataset.moneyFormat, true) : fallbackMoney.format(cents / 100);
      const labels = () => [...offer.querySelectorAll('.quantity-break[data-input]')];
      const rowKey = row => row.closest('.quantity-break').dataset.input + ':' + row.dataset.selectIndex;
      const rowValues = row => [...row.querySelectorAll('select')].map(select => select.value);
      const findVariant = values => variants.find(variant => Array.isArray(variant.options) && variant.options.length === values.length && variant.options.every((value, index) => value === values[index]));

      function restoreChoices() {
        offer.querySelectorAll('.quantity-break__selector-item').forEach(row => {
          const values = remembered.get(rowKey(row));
          if (!values) return;
          row.querySelectorAll('select').forEach((select, index) => {
            if ([...select.options].some(option => option.value === values[index])) select.value = values[index];
          });
        });
      }

      function cardSelection(label) {
        const quantity = Number(label.dataset.quantity);
        const rows = [...label.querySelectorAll('.quantity-break__selector-item')];
        const selected = rows.map(row => {
          const variant = findVariant(rowValues(row));
          if (variant) row.dataset.selectedId = String(variant.id);
          return variant;
        });
        return { quantity, selected, valid: totals.has(quantity) && rows.length === quantity && selected.every(variant => variant && variant.available !== false) };
      }

      function setMarkup(node, html) {
        const previous = rendered.get(node);
        if (previous?.source === html && previous.rendered === node.innerHTML) return;
        node.innerHTML = html;
        rendered.set(node, { source: html, rendered: node.innerHTML });
      }

      function updateCard(label, selection) {
        const total = totals.get(selection.quantity);
        if (total === undefined || !selection.selected.every(Boolean)) return;
        const compare = selection.selected.reduce((sum, variant) => sum + (compareBasis === 'price' ? variant.price : Math.max(variant.price, variant.compare_at_price || variant.price)), 0);
        const saved = Math.max(0, compare - total);
        const replacements = {
          quantity: String(selection.quantity), price: money(total), compare_price: money(compare),
          amount_saved: money(saved), amount_saved_rounded: money(Math.round(saved / 100) * 100),
          price_each: money(total / selection.quantity), compare_price_each: money(compare / selection.quantity)
        };
        label.querySelectorAll('.variant-price-update[data-text], .dynamic-price[data-text]').forEach(node => {
          const value = node.dataset.text.replace(/\[(quantity|price|compare_price|amount_saved|amount_saved_rounded|price_each|compare_price_each)\]/g, (_, key) => replacements[key]);
          setMarkup(node, value);
        });
        label.querySelector('.quantity-break__compare-price')?.classList.toggle('hidden', compare <= total);
        return { total, compare };
      }

      function updateMainPrices(prices) {
        if (!prices) return;
        const sectionId = offer.dataset.section;
        ['price-' + sectionId, 'sticky-atc-separate-price-' + sectionId].forEach(id => {
          const container = document.getElementById(id);
          if (!container) return;
          container.classList.remove('visibility-hidden');
          container.querySelector('.price')?.classList.toggle('price--on-sale', prices.compare > prices.total);
          container.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach(node => {
            if (node.textContent !== money(prices.total)) node.textContent = money(prices.total);
          });
          container.querySelectorAll('.price__compare-price .price-item--regular').forEach(node => {
            if (node.textContent !== money(prices.compare)) node.textContent = money(prices.compare);
          });
          const percentage = prices.compare > 0 ? Math.round((1 - prices.total / prices.compare) * 100) : 0;
          container.querySelectorAll('.price__badge-sale').forEach(badge => {
            const walker = document.createTreeWalker(badge, NodeFilter.SHOW_TEXT);
            let text;
            while ((text = walker.nextNode())) {
              const value = text.nodeValue.replace(/\d+(?:[.,]\d+)?(?=\s*%)/g, String(percentage));
              if (text.nodeValue !== value) text.nodeValue = value;
            }
          });
        });
        const buttonPrice = document.getElementById('main-addtocart-price-' + sectionId);
        if (buttonPrice && buttonPrice.textContent.trim()) buttonPrice.textContent = money(prices.total) + ' •';
        const stickyButtonPrice = document.getElementById('sticky-atc-price-' + sectionId);
        if (stickyButtonPrice) stickyButtonPrice.textContent = money(prices.total) + ' •';
      }

      function sync() {
        if (syncing) return offer.dataset.glovesBundleValid === 'true';
        syncing = true;
        try {
          restoreChoices();
          const cards = labels();
          let checked = offer.querySelector('input[name="quantity"]:checked');
          if (!checked) {
            checked = offer.querySelector('input[name="quantity"]:not(:disabled)');
            if (checked) checked.checked = true;
          }
          const active = checked && cards.find(label => label.dataset.input === checked.dataset.input);
          const selections = new Map();
          const prices = new Map();
          cards.forEach(label => {
            const selection = cardSelection(label);
            selections.set(label, selection);
            prices.set(label, updateCard(label, selection));
            if (offer.selectedVariants) offer.selectedVariants[label.dataset.input] = selection.valid ? selection.selected.map(variant => variant.id) : [];
          });
          const selection = selections.get(active);
          const valid = Boolean(selection?.valid);
          offer.formVariants = valid ? selection.selected.map(variant => variant.id) : [];
          offer.selectedQuantity = selection?.quantity || 0;
          productForm.quantityBreaks = offer;
          offer.dataset.glovesBundleValid = String(valid);
          idInput.disabled = !valid;
          if (valid) idInput.value = String(selection.selected[0].id);
          addButton.disabled = !valid || paymentPending || addButton.dataset.requiredFields !== addButton.dataset.validFields;
          if (!valid || paymentPending) addButton.setAttribute('aria-disabled', 'true');
          else if (!addButton.classList.contains('loading')) addButton.removeAttribute('aria-disabled');
          productInfo.querySelectorAll('.main-product-atc').forEach(button => {
            if (button !== addButton) button.disabled = !valid || paymentPending;
          });
          const grouped = new Map();
          if (valid) selection.selected.forEach(variant => grouped.set(String(variant.id), (grouped.get(String(variant.id)) || 0) + 1));
          let inputs = '';
          [...grouped].forEach(([id, quantity], index) => {
            if (/^\d+$/.test(id)) inputs += '<input type="hidden" name="items[' + index + '][id]" value="' + id + '"><input type="hidden" name="items[' + index + '][quantity]" value="' + quantity + '">';
          });
          if (variantInputs.innerHTML !== inputs) variantInputs.innerHTML = inputs;
          updateMainPrices(prices.get(active));
          if (valid && ownError === 'selection') {
            productForm.handleErrorMessage?.();
            ownError = false;
          }
          return valid;
        } finally {
          syncing = false;
        }
      }

      function queueSync() {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
          queued = false;
          if (offer.isConnected) sync();
        });
      }

      offer.addEventListener('change', event => {
        const row = event.target.closest('.quantity-break__selector-item');
        if (row && event.target.matches('select')) remembered.set(rowKey(row), rowValues(row));
        queueSync();
      }, true);
      if (typeof offer.initVariants === 'function') {
        const original = offer.initVariants;
        offer.initVariants = function (...args) {
          const result = original.apply(this, args);
          sync();
          return result;
        };
      }
      new MutationObserver(queueSync).observe(offer, { childList: true, subtree: true });
      productInfo.addEventListener('change', queueSync);
      const beforePurchase = event => {
        if (paymentPending) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (sync()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        ownError = 'selection';
        productForm.handleErrorMessage?.(window.variantStrings?.unavailable || 'This combination is unavailable.');
      };
      async function directCheckout(kind) {
        if (paymentPending || addButton.classList.contains('loading')) return;
        if (!sync()) {
          ownError = 'selection';
          productForm.handleErrorMessage?.(window.variantStrings?.unavailable || 'This combination is unavailable.');
          return;
        }
        const grouped = new Map();
        offer.formVariants.forEach(id => grouped.set(String(id), (grouped.get(String(id)) || 0) + 1));
        const items = [...grouped].sort(([left], [right]) => left.localeCompare(right)).map(([id, quantity]) => ({ id: Number(id), quantity }));
        const signature = JSON.stringify(items);
        if (ownError) productForm.handleErrorMessage?.();
        ownError = false;
        const locked = new Map([...offer.querySelectorAll('input, select'), ...form.querySelectorAll('button')].map(control => [control, control.disabled]));
        paymentPending = true;
        locked.forEach((_, control) => { control.disabled = true; });
        addButton.classList.add('loading');
        addButton.setAttribute('aria-disabled', 'true');
        const spinner = productForm.querySelector('.loading-overlay__spinner');
        spinner?.classList.remove('hidden');
        try {
          const cartUrl = (window.routes?.cart_url || '/cart').split('?')[0].replace(/\/$/, '');
          const cartResponse = await fetch(cartUrl.endsWith('.js') ? cartUrl : cartUrl + '.js', {
            method: 'GET', headers: { Accept: 'application/json' }, cache: 'no-store'
          });
          const cart = await cartResponse.json();
          if (cartResponse.ok === false || !Array.isArray(cart.items)) throw new Error(cart.description || cart.message || window.cartStrings?.error || 'Unable to read your cart. Please try again.');
          const variantIds = new Set(variants.map(variant => String(variant.id)));
          const productId = String(product.id || mount.dataset.productId).split('/').pop();
          const currentProduct = new Map();
          cart.items.forEach(item => {
            const id = String(item.variant_id || item.id);
            if (String(item.product_id) !== productId && !variantIds.has(id)) return;
            currentProduct.set(id, (currentProduct.get(id) || 0) + Number(item.quantity));
          });
          const productSignature = values => JSON.stringify([...values].sort(([left], [right]) => left.localeCompare(right)).map(([id, quantity]) => ({ id: Number(id), quantity })));
          const currentSignature = productSignature(currentProduct);
          const matchesSelection = currentSignature === signature;
          const matchesPrepared = preparedPaymentSignature === signature && preparedProductSignature === currentSignature;
          if (!matchesSelection && !matchesPrepared) {
            const expectedProduct = new Map(currentProduct);
            items.forEach(item => expectedProduct.set(String(item.id), (expectedProduct.get(String(item.id)) || 0) + item.quantity));
            preparedPaymentSignature = signature;
            preparedProductSignature = productSignature(expectedProduct);
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            const result = await response.json();
            if (response.ok === false || result.status) throw new Error(result.description || result.message || window.cartStrings?.error || 'Unable to add the selected gloves.');
            if (typeof window.publish === 'function' && events?.cartUpdate) window.publish(events.cartUpdate, { source: 'gloves-direct-checkout' });
          } else {
            preparedPaymentSignature = signature;
            preparedProductSignature = currentSignature;
          }
          const checkout = kind === 'paypal' ? window.itcCartDrawerPayPal : window.itcCartDrawerCheckout;
          if (typeof checkout === 'function') checkout();
          else window.location.assign('/checkout');
        } catch (error) {
          ownError = 'checkout';
          productForm.handleErrorMessage?.(error.message || window.cartStrings?.error || 'Unable to start checkout. Please try again.');
        } finally {
          paymentPending = false;
          locked.forEach((disabled, control) => { if (control.isConnected) control.disabled = disabled; });
          addButton.classList.remove('loading');
          spinner?.classList.add('hidden');
          sync();
        }
      }
      if (typeof window.subscribe === 'function' && events?.cartUpdate) {
        window.subscribe(events.cartUpdate, event => {
          if (event?.source !== 'gloves-direct-checkout') queueSync();
        });
      }
      form.addEventListener('submit', beforePurchase, true);
      form.addEventListener('click', event => {
        const paypal = event.target.closest('[onclick*="itcProdPagePayPal"]');
        const card = event.target.closest('[onclick*="itcProdPageCheckout"]');
        if ((paypal && form.contains(paypal)) || (card && form.contains(card))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          directCheckout(paypal ? 'paypal' : 'card');
          return;
        }
        if (event.target.closest('button')) beforePurchase(event);
      }, true);
      sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
